(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6371],{

/***/ 13144:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/entrenadores/[slug]",
      function () {
        return __webpack_require__(23453);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 31233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Image; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/components/Image/Picture.js


var defaultProps = {};
var propTypes = {
    children: (prop_types_default()).node.isRequired
};
function Picture(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
        children: children
    });
};
Picture.defaultProps = defaultProps;
Picture.propTypes = propTypes;

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./src/components/Image/Img.js



/* eslint-disable @next/next/no-img-element */ 


var Img_defaultProps = {
    fluid: true,
    title: null,
    className: null
};
var Img_propTypes = {
    src: (prop_types_default()).string.isRequired,
    alt: (prop_types_default()).string.isRequired,
    fluid: (prop_types_default()).bool,
    title: (prop_types_default()).string,
    className: (prop_types_default()).string
};
function Img(_param) {
    var src = _param.src, alt = _param.alt, fluid = _param.fluid, title = _param.title, className = _param.className, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "alt",
        "fluid",
        "title",
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread/* default */.Z)({
        src: src,
        alt: alt,
        title: title,
        className: (0,clsx_m/* default */.Z)(fluid && "h-auto max-w-full", className),
        loading: "lazy"
    }, rest));
}
Img.defaultProps = Img_defaultProps;
Img.propTypes = Img_propTypes;
var ImgForwardRef = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Img, (0,_object_spread/* default */.Z)({
        ref: ref
    }, props));
});
ImgForwardRef.displayName = "ImgForwardRef";
/* harmony default export */ var Image_Img = (ImgForwardRef);

;// CONCATENATED MODULE: ./src/components/Image/isRemote.js
function isRemote(src) {
    return src.indexOf("//") !== -1;
};

;// CONCATENATED MODULE: ./src/components/Image/localImageSource.js
function localImageSource(src) {
    return "/images/".concat(src);
};

;// CONCATENATED MODULE: ./src/components/Image/Source.js


var Source_defaultProps = {
    sizes: null,
    srcset: null,
    media: "all"
};
var Source_propTypes = {
    sizes: (prop_types_default()).string,
    srcset: (prop_types_default()).string,
    type: (prop_types_default()).string.isRequired,
    media: prop_types_default().oneOfType([
        prop_types_default().oneOf([
            "all",
            "print",
            "screen",
            "speech"
        ]),
        (prop_types_default()).string, 
    ])
};
function Source(param) {
    var sizes = param.sizes, srcset = param.srcset, type = param.type, media = param.media;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
        sizes: sizes,
        srcSet: srcset,
        type: type,
        media: media
    });
};
Source.defaultProps = Source_defaultProps;
Source.propTypes = Source_propTypes;

;// CONCATENATED MODULE: ./src/components/Image/renderSources.js


function renderSources(sources) {
    var keys = Object.keys(sources);
    if (keys === null || keys.length === 0) {
        return null;
    }
    return keys.map(function(type, index) {
        var src = sources[type];
        var srcSet = src;
        var sizes = null;
        if (Array.isArray(src) === true) {
            srcSet = src[0];
            sizes = src[1];
        }
        return renderSource(index, type, srcSet, sizes);
    });
};
function renderSource(index, type, srcSet) {
    var sizes = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Source, {
        type: type,
        srcSet: srcSet,
        sizes: sizes
    }, "source-".concat(index));
}

;// CONCATENATED MODULE: ./src/components/Image/Image.js










var Image_defaultProps = {
    fluid: false,
    sources: null,
    srcSet: null,
    sizes: null,
    className: ""
};
var Image_propTypes = {
    src: (prop_types_default()).string.isRequired,
    sources: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).object
    ]),
    srcSet: (prop_types_default()).string,
    sizes: (prop_types_default()).string,
    fluid: (prop_types_default()).bool,
    className: (prop_types_default()).string
};
function Image(_param) {
    var src = _param.src, sources = _param.sources, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "sources"
    ]);
    var hasSources = sources && sources.length !== 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Picture, {
        children: [
            hasSources && renderSources(sources),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Img, (0,_object_spread/* default */.Z)({
                src: isRemote(src) ? src : localImageSource(src)
            }, rest))
        ]
    });
}
Image.defaultProps = Image_defaultProps;
Image.propTypes = Image_propTypes;
var ImageForwardRef = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var alt = _param.alt, props = (0,_object_without_properties/* default */.Z)(_param, [
        "alt"
    ]);
    return (0,jsx_runtime.jsx)(Image, (0,_object_spread/* default */.Z)({
        ref: ref,
        alt: alt
    }, props));
});
ImageForwardRef.displayName = "ImageForwardRef";
/* harmony default export */ var Image_Image = (ImageForwardRef);

;// CONCATENATED MODULE: ./src/components/Image/index.js

/* harmony default export */ var components_Image = (Image_Image);


/***/ }),

/***/ 61525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TrainerVerified; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86010);
/* harmony import */ var _components_Tooltip__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95888);




var defaultProps = {
    className: "w-6 h-6"
};
var propTypes = {
    className: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};
function TrainerVerified(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Tooltip__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        tooltip: "Entrenador verificado",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
            className: "cursor-pointer rounded-full flex items-center justify-center text-green-500 hover:text-green-600 focus:outline-none relative",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(className, "fill-current relative z-10"),
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "aria-label": "Entrenador verificado",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        d: "M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
                        clipRule: "evenodd"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "absolute block w-4 h-4 bg-white rounded-full"
                })
            ]
        })
    });
};
TrainerVerified.defaultProps = defaultProps;
TrainerVerified.propTypes = propTypes;


/***/ }),

/***/ 23453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_Trainer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./src/components/Link/index.js + 2 modules
var Link = __webpack_require__(48300);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/Container/index.js
var Container = __webpack_require__(30341);
;// CONCATENATED MODULE: ./src/domain/Trainer/TrainerDesign.js

function TrainerDesign() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "absolute top-0 left-0 w-2/4 z-0 pointer-events-none transform -skew-y-6 mt-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-2/5 bg-gradient-to-r from-green-300 to-transparent h-20"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-5/6 bg-gradient-to-r from-green-200 to-transparent h-20"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-2/4 bg-gradient-to-r from-green-100 to-transparent h-20"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/domain/Trainer/TrainerSingleBaseLayout.js




var defaultProps = {};
var propTypes = {
    children: (prop_types_default()).node.isRequired
};
function TrainerSingleBaseLayout(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-gradient-to-b from-white to-gray-100 py-10 lg:py-20 relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TrainerDesign, {})
        ]
    });
};
TrainerSingleBaseLayout.defaultProps = defaultProps;
TrainerSingleBaseLayout.propTypes = propTypes;

;// CONCATENATED MODULE: ./src/domain/Trainer/TrainerSingleLayout.js


var TrainerSingleLayout_defaultProps = {};
var TrainerSingleLayout_propTypes = {};
function TrainerSingleLayout(param) {
    var sidebar = param.sidebar, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TrainerSingleBaseLayout, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "grid grid-cols-1 lg:grid-cols-12 lg:gap-16 relative z-10",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "lg:col-span-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "lg:sticky lg:top-32",
                        children: sidebar
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "lg:col-span-8 lg:pr-10",
                    children: children
                })
            ]
        })
    });
};
TrainerSingleLayout.defaultProps = TrainerSingleLayout_defaultProps;
TrainerSingleLayout.propTypes = TrainerSingleLayout_propTypes;

;// CONCATENATED MODULE: ./src/domain/Trainer/TrainerSidebar.js


var TrainerSidebar_defaultProps = {};
var TrainerSidebar_propTypes = {
    children: (prop_types_default()).node
};
function TrainerSidebar(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-white rounded-lg lg:rounded-xl shadow-xl overflow-hidden",
        children: children
    });
};
TrainerSidebar.defaultProps = TrainerSidebar_defaultProps;
TrainerSidebar.propTypes = TrainerSidebar_propTypes;

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/components/Image/index.js + 7 modules
var Image = __webpack_require__(31233);
;// CONCATENATED MODULE: ./src/components/FeaturedImage/FeaturedImage.js





var FeaturedImage_defaultProps = {
    sizes: null,
    srcSet: null,
    guid: null
};
var FeaturedImage_propTypes = {
    sizes: (prop_types_default()).string,
    srcSet: (prop_types_default()).string,
    sourceUrl: (prop_types_default()).string.isRequired,
    guid: (prop_types_default()).string,
    alt: (prop_types_default()).string.isRequired
};
function FeaturedImage(_param) {
    var sourceUrl = _param.sourceUrl, alt = _param.alt, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "sourceUrl",
        "alt"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, (0,_object_spread/* default */.Z)({
        src: sourceUrl,
        alt: alt
    }, rest));
};
FeaturedImage.defaultProps = FeaturedImage_defaultProps;
FeaturedImage.propTypes = FeaturedImage_propTypes;

;// CONCATENATED MODULE: ./src/components/FeaturedImage/index.js

/* harmony default export */ var components_FeaturedImage = (FeaturedImage);

// EXTERNAL MODULE: ./src/domain/Trainer/TrainerVerified.js
var TrainerVerified = __webpack_require__(61525);
// EXTERNAL MODULE: ./src/components/Tooltip/index.js + 1 modules
var Tooltip = __webpack_require__(95888);
;// CONCATENATED MODULE: ./src/domain/Trainer/TrainerInfoItem.js


var TrainerInfoItem_defaultProps = {};
var TrainerInfoItem_propTypes = {
    label: (prop_types_default()).string.isRequired,
    children: (prop_types_default()).node.isRequired
};
function TrainerInfoItem(param) {
    var label = param.label, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center w-full space-x-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-base font-medium",
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex-1 border-b-2 border-dashed border-gray-100"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-base",
                children: children
            })
        ]
    });
};
TrainerInfoItem.defaultProps = TrainerInfoItem_defaultProps;
TrainerInfoItem.propTypes = TrainerInfoItem_propTypes;

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./src/domain/Trainer/TrainerInfoCheck.js






var TrainerInfoCheck_defaultProps = {
    checked: false
};
var TrainerInfoCheck_propTypes = {
    checked: (prop_types_default()).bool
};
function TrainerInfoCheck(param) {
    var checked = param.checked, innerRef = param.innerRef;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)("cursor-pointer w-6 h-6 rounded-full flex items-center justify-center", {
            "bg-green-100 hover:bg-green-200 text-green-700": checked === true,
            "bg-red-100 hover:bg-red-200 text-red-700": checked === false
        }),
        ref: innerRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            className: "w-4 h-4",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 20 20",
            fill: "currentColor",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
                clipRule: "evenodd"
            })
        })
    });
}
TrainerInfoCheck.defaultProps = TrainerInfoCheck_defaultProps;
TrainerInfoCheck.propTypes = TrainerInfoCheck_propTypes;
/* harmony default export */ var Trainer_TrainerInfoCheck = (/*#__PURE__*/(0,react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TrainerInfoCheck, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        innerRef: ref
    }));
}));

;// CONCATENATED MODULE: ./src/domain/Trainer/TrainerInfoCheckItem.js





var TrainerInfoCheckItem_defaultProps = {
    positiveValue: "S\xed",
    negativeValue: "No",
    value: false
};
var TrainerInfoCheckItem_propTypes = {
    value: (prop_types_default()).bool,
    label: (prop_types_default()).string.isRequired,
    positiveValue: (prop_types_default()).string,
    negativeValue: (prop_types_default()).string
};
function TrainerInfoCheckItem(param) {
    var value = param.value, label = param.label, positiveValue = param.positiveValue, negativeValue = param.negativeValue;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TrainerInfoItem, {
        label: label,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
            tooltip: value ? positiveValue : negativeValue,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trainer_TrainerInfoCheck, {
                checked: value
            })
        })
    });
};
TrainerInfoCheckItem.defaultProps = TrainerInfoCheckItem_defaultProps;
TrainerInfoCheckItem.propTypes = TrainerInfoCheckItem_propTypes;

;// CONCATENATED MODULE: ./src/domain/Trainer/TrainerInfoPrivateTraining.js


function TrainerInfoPrivateTraining(param) {
    var value = param.value;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TrainerInfoCheckItem, {
        label: "Cursos privados (in-company)",
        value: value
    });
};

;// CONCATENATED MODULE: ./src/domain/Trainer/TrainerInfoCoaching.js


function TrainerInfoCoaching(param) {
    var value = param.value;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TrainerInfoCheckItem, {
        label: "Coaching",
        value: value
    });
};

;// CONCATENATED MODULE: ./src/domain/Trainer/TrainerInfoLanguage.js


var TrainerInfoLanguage_defaultProps = {
    lang: null
};
var TrainerInfoLanguage_propTypes = {
    lang: (prop_types_default()).string
};
function TrainerInfoLanguage(param) {
    var lang = param.lang;
    var name = getLanguage(lang);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: "inline-flex leading-none px-3 py-1 rounded-full text-xs bg-teal-100 text-teal-900 font-medium focus:outline-none",
        type: "button",
        children: name
    });
};
function getLanguage(lang) {
    switch(lang){
        case "spanish":
            return "Espa\xf1ol";
        case "english":
            return "Ingl\xe9s";
        default:
            return "Indefinido";
    }
}
TrainerInfoLanguage.defaultProps = TrainerInfoLanguage_defaultProps;
TrainerInfoLanguage.propTypes = TrainerInfoLanguage_propTypes;

;// CONCATENATED MODULE: ./src/domain/Trainer/TrainerInfoLanguages.js




var TrainerInfoLanguages_defaultProps = {};
var TrainerInfoLanguages_propTypes = {
    languages: prop_types_default().arrayOf((prop_types_default()).string).isRequired
};
function TrainerInfoLanguages(param) {
    var languages = param.languages;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TrainerInfoItem, {
        label: "Idiomas",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex items-center space-x-1",
            children: languages.map(function(lang) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TrainerInfoLanguage, {
                    lang: lang
                }, lang);
            })
        })
    });
};
TrainerInfoLanguages.defaultProps = TrainerInfoLanguages_defaultProps;
TrainerInfoLanguages.propTypes = TrainerInfoLanguages_propTypes;

;// CONCATENATED MODULE: ./src/domain/Trainer/TrainerInfoShape.js

var TrainerInfoShape_defaultProps = {};
var TrainerInfoShape_propTypes = {
    city: (prop_types_default()).string,
    coaching: (prop_types_default()).bool,
    languages: (prop_types_default()).array,
    privateTraining: (prop_types_default()).bool,
    trainings: prop_types_default().arrayOf((prop_types_default()).object)
};


;// CONCATENATED MODULE: ./src/domain/Trainer/TrainerInfo.js






var TrainerInfo_defaultProps = (0,_object_spread/* default */.Z)({}, TrainerInfoShape_defaultProps);
var TrainerInfo_propTypes = (0,_object_spread/* default */.Z)({}, TrainerInfoShape_propTypes);
function TrainerInfo(param) {
    var privateTraining = param.privateTraining, coaching = param.coaching, languages = param.languages;
    var hasPrivateTraining = privateTraining !== null;
    var hasCoaching = coaching !== null;
    var hasLanguages = languages !== null && languages.length !== 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "space-y-2 pt-4",
        children: [
            hasPrivateTraining && /*#__PURE__*/ (0,jsx_runtime.jsx)(TrainerInfoPrivateTraining, {
                value: privateTraining
            }),
            hasCoaching && /*#__PURE__*/ (0,jsx_runtime.jsx)(TrainerInfoCoaching, {
                value: coaching
            }),
            hasLanguages && /*#__PURE__*/ (0,jsx_runtime.jsx)(TrainerInfoLanguages, {
                languages: languages
            })
        ]
    });
};
TrainerInfo.defaultProps = TrainerInfo_defaultProps;
TrainerInfo.propTypes = TrainerInfo_propTypes;

;// CONCATENATED MODULE: ./src/domain/Trainer/TrainerEmail.js

function TrainerEmail(param) {
    var email = param.email;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "text-base",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: "text-green-500 hover:text-gray-900",
            href: "mailto:".concat(email),
            children: email
        })
    });
};

;// CONCATENATED MODULE: ./src/domain/Trainer/TrainerCity.js


var TrainerCity_defaultProps = {};
var TrainerCity_propTypes = {
    city: (prop_types_default()).string.isRequired
};
function TrainerCity(param) {
    var city = param.city;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center space-x-1 pt-1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                className: "w-4 h-4 fill-current text-gray-300",
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 20 20",
                fill: "currentColor",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    d: "M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z",
                    clipRule: "evenodd"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-gray-500",
                children: city
            })
        ]
    });
};
TrainerCity.defaultProps = TrainerCity_defaultProps;
TrainerCity.propTypes = TrainerCity_propTypes;

;// CONCATENATED MODULE: ./src/domain/Trainer/TrainerSocialAction.js


var TrainerSocialAction_propTypes = {
    url: (prop_types_default()).string.isRequired,
    children: (prop_types_default()).string.isRequired
};
function TrainerSocialAction(param) {
    var url = param.url, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        href: url,
        className: "flex lg:inline-flex items-center justify-center space-x-2 rounded-full bg-gray-900 hover:bg-gray-700 focus:ring-4 focus:ring-gray-600 focus:ring-opacity-20 focus:bg-gray-900 text-white focus:outline-none px-5 py-2 text-sm font-semibold shadow leading-5 text-center whitespace-nowrap",
        children: children
    });
};
TrainerSocialAction.propTypes = TrainerSocialAction_propTypes;

;// CONCATENATED MODULE: ./src/domain/Trainer/TrainerSocialLinkedIn.js



var TrainerSocialLinkedIn_propTypes = {
    url: (prop_types_default()).string.isRequired
};
function TrainerSocialLinkedIn(param) {
    var url = param.url;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TrainerSocialAction, {
        url: url,
        children: "LinkedIn"
    });
};
TrainerSocialLinkedIn.propTypes = TrainerSocialLinkedIn_propTypes;

;// CONCATENATED MODULE: ./src/domain/Trainer/TrainerSocialEmail.js



var TrainerSocialEmail_propTypes = {
    email: (prop_types_default()).string.isRequired
};
function TrainerSocialEmail(param) {
    var email = param.email;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TrainerSocialAction, {
        url: "mailto:".concat(email),
        children: "Enviar mensaje"
    });
};
TrainerSocialEmail.propTypes = TrainerSocialEmail_propTypes;

;// CONCATENATED MODULE: ./src/domain/Trainer/TrainerSocialShape.js

var TrainerSocialShape_defaultProps = {
    email: null,
    website: null,
    linkedin: null,
    twitter: null
};
var TrainerSocialShape_propTypes = {
    email: (prop_types_default()).string,
    website: (prop_types_default()).string,
    linkedin: (prop_types_default()).string,
    twitter: (prop_types_default()).string
};


;// CONCATENATED MODULE: ./src/domain/Trainer/TrainerActions.js





var TrainerActions_defaultProps = (0,_object_spread/* default */.Z)({}, TrainerSocialShape_defaultProps);
var TrainerActions_propTypes = (0,_object_spread/* default */.Z)({}, TrainerSocialShape_propTypes);
function TrainerActions(param) {
    var email = param.email, linkedin = param.linkedin;
    var hasEmail = email !== null;
    var hasLinkedIn = linkedin !== null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pt-4 flex -mx-2",
        children: [
            hasEmail && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrainerSocialEmail, {
                    email: email
                })
            }),
            hasLinkedIn && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrainerSocialLinkedIn, {
                    url: linkedin
                })
            })
        ]
    });
};
TrainerActions.defaultProps = TrainerActions_defaultProps;
TrainerActions.propTypes = TrainerActions_propTypes;

// EXTERNAL MODULE: ./src/shapes/FeaturedImage.js
var shapes_FeaturedImage = __webpack_require__(94992);
;// CONCATENATED MODULE: ./src/domain/Trainer/TrainerShape.js




var TrainerShape_defaultProps = {
    info: TrainerInfoShape_defaultProps,
    social: TrainerSocialShape_defaultProps
};
var TrainerShape_propTypes = {
    title: (prop_types_default()).string,
    featuredImage: shapes_FeaturedImage/* default */.Z,
    info: prop_types_default().shape(TrainerInfoShape_propTypes),
    social: prop_types_default().shape(TrainerSocialShape_propTypes)
};


;// CONCATENATED MODULE: ./src/domain/Trainer/TrainerCard.js









var TrainerCard_defaultProps = (0,_object_spread/* default */.Z)({}, TrainerShape_defaultProps);
var TrainerCard_propTypes = (0,_object_spread/* default */.Z)({}, TrainerShape_propTypes);
function TrainerCard(param) {
    var title = param.title, featuredImage = param.featuredImage, info = param.info, social = param.social;
    var hasEmail = social.email !== null;
    var hasCity = info.city !== null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "border-b-8 border-green-500 relative",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FeaturedImage, (0,_object_spread/* default */.Z)({
                    className: "rounded-t-lg w-full",
                    alt: title
                }, featuredImage.node))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "divide-y p-6 space-y-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "space-y-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                className: "font-semibold text-2xl flex items-center space-x-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TrainerVerified/* default */.Z, {})
                                ]
                            }),
                            hasEmail && /*#__PURE__*/ (0,jsx_runtime.jsx)(TrainerEmail, {
                                email: social.email
                            }),
                            hasCity && /*#__PURE__*/ (0,jsx_runtime.jsx)(TrainerCity, {
                                city: info.city
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TrainerInfo, (0,_object_spread/* default */.Z)({}, info)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TrainerActions, (0,_object_spread/* default */.Z)({}, social))
                ]
            })
        ]
    });
};
TrainerCard.defaultProps = TrainerCard_defaultProps;
TrainerCard.propTypes = TrainerCard_propTypes;

;// CONCATENATED MODULE: ./src/domain/Trainer/TrainerContent.js


var TrainerContent_defaultProps = {};
var TrainerContent_propTypes = {
    content: (prop_types_default()).string.isRequired
};
function TrainerContent(param) {
    var content = param.content;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "prose lg:prose-lg",
        dangerouslySetInnerHTML: {
            __html: content
        }
    });
};
TrainerContent.defaultProps = TrainerContent_defaultProps;
TrainerContent.propTypes = TrainerContent_propTypes;

;// CONCATENATED MODULE: ./src/domain/Trainer/TrainerPageSection.js


var TrainerPageSection_defaultProps = {};
var TrainerPageSection_propTypes = {
    title: (prop_types_default()).string.isRequired,
    children: (prop_types_default()).node.isRequired
};
function TrainerPageSection(param) {
    var title = param.title, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "space-y-4 lg:space-y-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "font-semibold text-xl lg:text-2xl xl:text-3xl lg:tracking-tight",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full",
                children: children
            })
        ]
    });
};
TrainerPageSection.defaultProps = TrainerPageSection_defaultProps;
TrainerPageSection.propTypes = TrainerPageSection_propTypes;

;// CONCATENATED MODULE: ./src/domain/Trainer/TrainerCertifications.js





function TrainerCertificationBadge(param) {
    var title = param.title, badge = param.badge, uri = param.uri;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
        tooltip: title,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
            href: uri,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: badge.sourceUrl,
                width: 200,
                height: 200,
                alt: title
            })
        })
    });
}
function TrainerCertifications(param) {
    var certifications = param.certifications;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TrainerPageSection, {
        title: "Certificaciones obtenidas",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "grid grid-cols-1 lg:grid-cols-12 lg:gap-6",
            children: certifications.map(function(param) {
                var id = param.id, title = param.title, featuredImage = param.featuredImage, uri = param.uri;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "lg:col-span-2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrainerCertificationBadge, {
                        title: title,
                        badge: featuredImage.node,
                        uri: uri
                    })
                }, id);
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/domain/Trainer/TrainerTrainings.js



function TrainerTrainings(param) {
    var trainings = param.trainings;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TrainerPageSection, {
        title: "Cursos que imparte",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "prose lg:prose-lg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: trainings.map(function(param) {
                    var id = param.id, title = param.title, uri = param.uri;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: uri,
                            children: title
                        })
                    }, id);
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/domain/Trainer/Trainer.js









function Trainer(param) {
    var trainer = param.trainer;
    var ref, ref1;
    var hasCertifications = ((ref = trainer.info) === null || ref === void 0 ? void 0 : ref.certifications) !== null;
    var hasTrainings = ((ref1 = trainer.info) === null || ref1 === void 0 ? void 0 : ref1.trainings) !== null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TrainerSingleLayout, {
        sidebar: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrainerSidebar, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrainerCard, (0,_object_spread/* default */.Z)({}, trainer))
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "space-y-6 lg:space-y-10 divide-y-2",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "space-y-6 pt-8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                            className: "inline-flex items-center space-x-2 font-semibold text-green-500 text-lg",
                            href: "/entrenadores",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    className: "w-4 h-4",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 20 20",
                                    fill: "currentColor",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        fillRule: "evenodd",
                                        d: "M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z",
                                        clipRule: "evenodd"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: "Volver al listado de entrenadores"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "text-xl lg:text-4xl xl:text-5xl font-semibold lg:font-extrabold",
                            children: trainer.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TrainerContent, {
                            content: trainer.content
                        })
                    ]
                }),
                hasCertifications && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pt-6 lg:pt-10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrainerCertifications, {
                        certifications: trainer.info.certifications
                    })
                }),
                hasTrainings && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pt-6 lg:pt-10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrainerTrainings, {
                        trainings: trainer.info.trainings
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/domain/Trainer/index.js

/* harmony default export */ var domain_Trainer = (Trainer);

;// CONCATENATED MODULE: ./src/pages/entrenadores/[slug].js


var __N_SSG = true;
function _slug_Trainer(param) {
    var trainer = param.trainer;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(domain_Trainer, {
        trainer: trainer
    });
};


/***/ }),

/***/ 94992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = (prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({
    node: prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({
        sizes: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
        srcSet: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
        sourceUrl: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
        guid: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
        slug: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string)
    })
}));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(13144); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);